import { AppBar, Button, Grid, Hidden, IconButton, Toolbar, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { IconMenu, IconPrint } from "src/common/icons";
import { IAppReduxState } from "src/common/types";
import { LocalesContext } from "src/common/contexts";
import { removeToken } from "src/helpers";
import MobileMenu from "../MobileMenu";
import Languages from "./Languages";

const useStyles = makeStyles((theme: any) => ({
  appBar: {
    "@media print": {
      display: "none" as "none"
    },
    marginBottom: 32,
    zIndex: theme.zIndex.drawer + 1
  },
  inner: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    [theme.breakpoints.up("md")]: {
      maxWidth: "941px",
      width: "calc(100% - 454px)"
    }
  },
  leftContainer: {
    [theme.breakpoints.up("md")]: {
      marginRight: "32px",
      width: "195px"
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      display: "flex"
    }
  },
  logo: {
    [theme.breakpoints.down("sm")]: {
      height: 32,
      width: 64
    },
    maxHeight: "100%",
    position: "relative" as "relative"
  },
  logoutButton: {
    fontSize: "1.4rem",
    textTransform: "none" as "none"
  },
  mobileMenu: {
    color: "#fff",
    fontSize: "20px"
  },
  printLabel: {
    margin: "0 0 0 6px",
    textTransform: "none" as "none"
  },
  rightContainer: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "32px",
      width: "195px"
    }
  }
}));
interface IStateProps {
  loggedIn: boolean;
  printVisible: boolean;
}
type Props = RouteComponentProps & IStateProps;

const logout = () => {
  removeToken();
  sessionStorage.removeItem("nextUrl");
  window.location.href = `${origin}/oidcoauth2?logout=${origin}`;
};

const Header = (props: Props) => {
  const { locales } = React.useContext(LocalesContext);

  const {
    t,
    i18n: { language: lng }
  } = useTranslation();

  const { history, loggedIn, printVisible } = props;
  const handlePrint = React.useCallback(() => window.print(), []);
  const classes = useStyles();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const handleMobileMenuClick = React.useCallback(() => {
    setMobileMenuOpen(!mobileMenuOpen);
  }, [mobileMenuOpen]);
  const handleMenuClose = React.useCallback(() => {
    setMobileMenuOpen(false);
  }, []);
  return (
    <AppBar className={classes.appBar} position="fixed" color="primary">
      <Toolbar>
        <Grid container justifyContent="space-between">
          <Grid className={classes.leftContainer} item>
            <Link to={`/${lng}/dashboard/forward`}>
              <img
                className={classes.logo}
                src="/svgs/logo-auto1-group.svg"
                alt="AUTO1 Group - Feedback Tool"
                title="AUTO1 Group - Feedback Tool"
              />
            </Link>
          </Grid>
          <Grid className={classes.inner} item>
            <Hidden smDown>
              {printVisible && (
                <Button color="inherit" onClick={handlePrint}>
                  <IconPrint />
                  <Typography className={classes.printLabel} color="inherit">
                    {t(`feedback.header.print`)}
                  </Typography>
                </Button>
              )}
            </Hidden>
            <Hidden smDown={loggedIn ? true : false}>
              <Languages location={location} history={history} lngs={locales} />
            </Hidden>
            <Hidden smDown>
              {loggedIn && (
                <Button className={classes.logoutButton} onClick={logout} color="inherit">
                  Log out
                </Button>
              )}
            </Hidden>
            <Hidden mdUp>
              {loggedIn && (
                <>
                  <IconButton className={classes.mobileMenu} onClick={handleMobileMenuClick}>
                    <IconMenu />
                  </IconButton>
                  <MobileMenu onClose={handleMenuClose} open={mobileMenuOpen} history={history} />
                </>
              )}
            </Hidden>
          </Grid>
          <Hidden mdDown>
            <Grid className={classes.rightContainer} item />
          </Hidden>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = ({
  currentUser: { userData },
  talkSheet: { talkSheet },
  myQuestionnaire: { questionnaire }
}: IAppReduxState): IStateProps => ({
  loggedIn: userData.id.length > 0,
  printVisible: !!talkSheet || !!questionnaire
});

export default React.memo(withRouter(connect(mapStateToProps)(Header)));
